// Simple browser-compatible configuration
console.log('🔧 Config: All process.env:', process.env);
console.log('🔧 Config: Raw BANK_API_URL:', process.env.BANK_API_URL);
console.log('🔧 Config: Raw CONVERSATION_SERVICE_API_URL:', process.env.CONVERSATION_SERVICE_API_URL);
// Runtime configuration for browser environment
const getRuntimeConfig = () => {
    // Try to get config from window.__ENV__ (injected by server)
    if (typeof window !== 'undefined' && window.__ENV__) {
        return window.__ENV__;
    }
    // Fallback to build-time environment variables
    return process.env;
};
const runtimeConfig = getRuntimeConfig();
console.log('🔧 Config: Runtime config:', runtimeConfig);
// Create a generic config object with all environment variables
export const config = {};
// Add all environment variables to config
Object.keys(runtimeConfig).forEach(key => {
    config[key] = runtimeConfig[key];
});
// Add convenience properties for commonly used values (using any available variable name)
config.bankApiUrl = config.BANK_API_URL || config.REACT_APP_BANK_API_URL || 'http://localhost:4000';
config.conversationServiceUrl = config.CONVERSATION_SERVICE_API_URL || config.REACT_APP_SUPPORT_PLATFORM_URL || config.REACT_APP_CONVERSATION_SERVICE_URL || 'https://conversation.dev.charmsecurity.com';
config.bankApiKey = config.BANK_API_KEY || config.REACT_APP_BANK_API_KEY || 'bank-api-key-123';
// Descope Authentication Configuration
config.descopeProjectId = config.REACT_APP_DESCOPE_PROJECT_ID || 'P2zXhzfgMSH6uga2xZ8amMARYphg';
config.descopeFlowId = config.REACT_APP_DESCOPE_FLOW_ID || 'sign-up-or-in';
config.descopeTheme = config.REACT_APP_DESCOPE_THEME || 'light';
config.isDevelopment = runtimeConfig.NODE_ENV === 'development';
config.cdnUrl = config.REACT_APP_CDN_URL;
console.log('🔧 Config: Final config object:', config);
console.log('🔧 Config: Bank API URL:', config.bankApiUrl);
console.log('🔧 Config: Conversation Service URL:', config.conversationServiceUrl);
console.log('🔧 Config: Descope Project ID:', config.descopeProjectId);
export default config;
